import _ from "lodash"
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container";
import { HiOutlineTrash } from "react-icons/hi";

export const DBaasProgram = ({dbas,websites,handleInnerFormChange,selectedProgram, onFormChange,applications,endPoints, environments, phases, services, publics, privates, networks, planItems, onFormItemChange, deleteSelectedPlan }: any) => {
  const programDuration: any = [
    { Description: '1 week', Value: 1 },
    { Description: '2 weeks', Value: 2 },
    { Description: '1 Month', Value: 3 },
    { Description: '2 Months', Value: 4 },
    { Description: '3 Months', Value: 5 },
    { Description: '6 Months', Value: 6 },
    { Description: '1 Year', Value: 7 },
  ]
    return (
<>

                        <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {/* <InputContainer
          label="Name"

          onValueChange={(event: any, newValue: any) => {
            onFormItemChange({
              value: event.target.value,
              field: 'Name',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedPlan?.Name}

      /> */}
      <InputContainer
   label="DBaaS EndPoint Name" 
                    labelField="Name"
                    list={endPoints}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DBaaSEndPointIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DBaaSEndPointIds}
/>
<InputContainer
   label="DBaaS Environment Name" 
                    labelField="Name"
                    list={environments}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DBaaSEnvironmentIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DBaaSEnvironmentIds}
/>

<InputContainer
   label="DBaaS Network Name" 
                    labelField="DisplayName"
                    list={networks}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DBaaSNetworkIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DBaaSNetworkIds}
/>
<InputContainer
     label="Application Name" 
                      labelField="DisplayName"
                      list={applications}
                      onValueChange={(newValue: any) => {
                        const valueData: any = newValue.map((option: any) => option?.value)
                        handleInnerFormChange(
                          valueData,
                          'ApplicationMappings.ApplicationIds',
                          selectedProgram?.ApplicationMappings
                        )
                      }}
                      type="multiselect"
                      valueField="Id"
                      value={selectedProgram?.ApplicationMappings?.ApplicationIds}
  />
<InputContainer
   label="DBaaS Phase Name" 
                    labelField="Name"
                    list={phases}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DBaaSPhaseIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DBaaSPhaseIds}
/>
<InputContainer
   label="DBaaS Service Name" 
                    labelField="Name"
                    list={services}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DBaaSServiceIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DBaaSServiceIds}
/>

<InputContainer
   label="Digital Private Infrastructure Name" 
                    labelField="Name"
                    list={privates}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DigitalPrivateInfrastructureIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DigitalPrivateInfrastructureIds}
/>

<InputContainer
   label="Digital Public Infrastructure Name" 
                    labelField="Name"
                    list={publics}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'DigitalPublicInfrastructureIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.DigitalPublicInfrastructureIds}
/>

<InputContainer
   label="Platform Websites Name" 
                    labelField="WebsiteName"
                    list={websites}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value)
                      onFormChange({
                        value: valueData,
                        field: 'PlatformWebsiteIds'
                      });
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={planItems?.PlatformWebsiteIds}
/>
 <InputContainer
                           label="DBA Name"
                           labelField="Name"
                           list={dbas}
                           onValueChange={( newValue: any) => {
                            const valueData: any = newValue.map((option: any) => option?.value)
                            onFormChange({
                              value: valueData,
                              field: 'DBAIds'
                            });
                          }}
                          type="multiselect"
                           value={planItems?.DBAIds}
                           valueField="Id"
                       />

<InputContainer
          label="Price"

          onValueChange={(event: any, newValue: any) => {
            onFormChange({
              value: event.target.value,
              field: 'Price'
            });
          }}
          type="number"
          value={planItems?.Price}

      />
                        <InputContainer
                    label="Program Duration"
                     labelField="Description"
                    list={programDuration}
                    onValueChange={(event: any, newValue: any) => {
                      onFormChange({
                        value: event.target.value,
                        field: 'ProgramDuration'
                      });
                    } }
                    optionName="Choose program duration"
                    type="select"
                    value={planItems?.ProgramDuration} 
                    valueField="Description"/>
      <InputContainer
          label="Renewal"

          onValueChange={(event: any, newValue: any) => {
            onFormChange({
              value: event,
              field: 'IsRenewal'
            });
          }}
          type="checkbox"
          value={planItems?.IsRenewal}

      />
                        </div>
</>


    )
}